import React from "react";
import { IUserAuthPayload } from "../../../laco-common/base/models/user";
import "./UserImageIcon.scss";

type UserImageProps = {
	userPayload: IUserAuthPayload;
};

export const UserImageIcon: React.FC<UserImageProps> = (props: UserImageProps) => {
	return (
		<span className="user-image-icon d-inline-flex align-items-center justify-content-center">
			<span className="initials">{props.userPayload.nameInitials}</span>
		</span>
	);
};
